module.exports = __webpack_public_path__ + "static/media/logo-xx.af4136f5.png";